export var AuthenticationType = /*#__PURE__*/function (AuthenticationType) {
  AuthenticationType["Token"] = "token";
  AuthenticationType["AuthorizationCode"] = "code";
  AuthenticationType["IdToken"] = "id_token";
  return AuthenticationType;
}(AuthenticationType || {});